import { CollapsibleSectionHeader } from "lib/components/studio/CollapsibleSectionHeader";
import { useState } from "react";
import Select from "ui/forms/Select";
import IconLineArrow from "ui/icons/IconLineArrow";
import IconTrash from "ui/icons/IconTrash";
import styles from "./materialEditor.module.scss";

interface LibraryListAddButtonProps {
  categoryName: string;
  availableLibraries?: string[];
  addLibrary: (name: string) => void;
}

interface LibraryListProps {
  categoryName: string;
  selectedLibraries: string[];
  removeLibrary: (name: string) => void;
  showLibrary: (name: string) => void;
}

export function LibraryListAddButton({ categoryName, availableLibraries, addLibrary }: LibraryListAddButtonProps) {
  return (
    <Select
      value=""
      placeholder={"Add " + categoryName}
      options={(availableLibraries ?? []).map((lib) => {
        return { value: lib, label: lib };
      })}
      onChange={(lib) => {
        addLibrary(lib as string);
      }}
      clearOnChange
    />
  );
}

function LibraryList({ categoryName, selectedLibraries, removeLibrary, showLibrary }: LibraryListProps) {
  const [expanded, setExpanded] = useState<boolean>(true);

  return (
    <div className={styles.libraryList}>
      <CollapsibleSectionHeader
        header={`Compatible ${categoryName}`}
        expanded={expanded}
        setExpanded={setExpanded}
        topBorder={false}
        style={{ fontSize: "14px" }}
      ></CollapsibleSectionHeader>
      {expanded ? (
        <div>
          {selectedLibraries.length === 0 ? <div className={styles.libraryListEmpty}>No libraries selected</div> : ""}
          <ul>
            {selectedLibraries.map((name) => (
              <li className={styles.libraryListItem} key={name}>
                {name}
                <span style={{ marginLeft: "auto" }}>
                  <button className={styles.libraryListButton} onClick={() => removeLibrary(name)}>
                    <IconTrash />
                  </button>
                  <button className={styles.libraryListButton} onClick={() => showLibrary(name)}>
                    Preview&nbsp;
                    <IconLineArrow />
                  </button>
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default LibraryList;
